import {Component,  Input, OnDestroy, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';

import {DxFormModule, DxScrollViewModule, DxSelectBoxModule} from "devextreme-angular";
import {DxiItemModule} from "devextreme-angular/ui/nested";
import {FormLabelMode, LabelLocation} from "devextreme/ui/form";
import {DkDxDataCtlTableComponent} from "../dk-dx-data-ctl-table/dk-dx-data-ctl-tablecomponent";
import {Observable, Subject, takeUntil} from "rxjs";
import {HistoryService} from "./history.service";
import {CtlIkaPersonelComponent} from "../controls/ctl-ika-personel/ctl-ika-personel.component";
import {CtlGenKontrolComponent} from "../controls/ctl-gen-kontrol/ctl-gen-kontrol.component";
import {CtGenLookupComponent} from "../ct-gen-lookup/ct-gen-lookup.component";
import {CtlGenKisiComponent} from "../controls/ctl-gen-kisi/ctl-gen-kisi.component";
import {CtlTebKurumSinifComponent} from "../controls/ctl-teb-kurum-sinif/ctl-teb-kurum-sinif.component";
import {CtlTemHarcamaComponent} from "../controls/ctl-tem-harcama/ctl-tem-harcama.component";
import {CtlTemTaahhutComponent} from "../controls/ctl-tem-taahhut/ctl-tem-taahhut.component";
import {ColumnModel} from "../../models/dx-data-table.model";
import {OrtakService} from "../../services/ortak.service";
import { DkGlobalUserSettingsService } from '../../services/dk-global-user-settings.service';
import { DataCoreService, DlistDto} from "@dabnet-kamu/libs/ui";


export class HistoryFilterData {
  Donem:number
  Kod:any
  kayitAdi: string
  kaydedenKod?:number
  kayitTarih?:Date
  sonDegistirenKod?:number
  degisiklikTarih?:Date
}

@Component({
  selector: 'dk-history',
  standalone: true,
  imports: [CommonModule, DxSelectBoxModule, DxiItemModule,
    DkDxDataCtlTableComponent, DxFormModule, DxScrollViewModule, CtlGenKontrolComponent,
  ],
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss'],
})
export class HistoryComponent implements OnInit, OnDestroy{
  @Input() public entityName: string;
  @Input() public selectedRowData: HistoryFilterData;
  historyFormData:HistoryFilterData = new HistoryFilterData();
  labelMode:FormLabelMode = this.dkGlobalUserSettingsService.globalLabelMode;
  labelLocation:LabelLocation = this.dkGlobalUserSettingsService.globalLabelLocation;
  historyGridCtl$: Observable<DlistDto>;
  public columnList: ColumnModel[];
  public dataSource:any;
  yeniDegerKolonu:any=[]
  eskiDegerKolonu:any=[]
  HistoryRowSelected:boolean=false
  private destroy$ = new Subject<void>();

  constructor(public historyService:HistoryService, public ortakService: OrtakService,
    private dkGlobalUserSettingsService:DkGlobalUserSettingsService,
    private dataCoreService:DataCoreService
  ) {
    this.historyGridCtl$ = this.historyService.gridControlsHistoryList$
    this.historyService.getHistoryDlist('vLogAudit')
    // historyService providedIn:'root' - kalıcı bir singleton, gridControlsHistoryList$ hiç
    // tamamlanmıyor. takeUntil olmadan bu subscribe popup her kapanıp açıldığında bir öncekini
    // hayatta bırakıyor; birkaç açılıştan sonra ayni emisyon N kere işleniyor (grid'in birden
    // fazla kez yeniden render olması, tekrarlayan vLogAudit isteği).
    this.historyService.gridControlsHistoryList$.pipe(takeUntil(this.destroy$)).subscribe(res=>{
      this.columnList = this.ortakService.setRecursiveFieldData([res], false);
    })

  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit() {
    if(this.entityName && this.selectedRowData){
      this.historyFormData.kayitAdi = this.entityName;
      this.historyFormData.Kod = this.selectedRowData?.Kod;

      // historyEntityName her zaman gerçek bir OData entity'sine karşılık gelmiyor (form kodu da
      // olabiliyor). selectedRowData bu alanları zaten taşıyorsa (ör. FormData'dan kopyalanmışsa)
      // tekrar sorgu atmıyoruz; aksi halde tek seferlik OData'dan çekmeyi deniyoruz.
      if (this.selectedRowData.kayitTarih || this.selectedRowData.kaydedenKod || this.selectedRowData.sonDegistirenKod || this.selectedRowData.degisiklikTarih) {
        this.historyFormData.kaydedenKod = this.selectedRowData?.kaydedenKod;
        this.historyFormData.sonDegistirenKod = this.selectedRowData?.sonDegistirenKod;
        this.historyFormData.kayitTarih = this.selectedRowData?.kayitTarih;
        this.historyFormData.degisiklikTarih = this.selectedRowData?.degisiklikTarih;
      } else {
        const ds = this.dataCoreService.getOData(this.entityName);
        ds.select(['Kod','KayitKullaniciKod','KayitTarih','DegisKullaniciKod','DegisTarih']);
        ds.filter(['Kod', '=', this.selectedRowData?.Kod]);
        ds.load().then(res => {
          if(res && res.length > 0){
            this.historyFormData.kaydedenKod = res[0]?.KayitKullaniciKod;
            this.historyFormData.sonDegistirenKod = res[0]?.DegisKullaniciKod;
            this.historyFormData.kayitTarih = res[0]?.KayitTarih;
            this.historyFormData.degisiklikTarih = res[0]?.DegisTarih;
          }
        }).catch(() => {
          // entityName OData'dan sorgulanamıyorsa (ör. form kodu, gerçek tablo değil) sessizce vazgeç
        });
      }

      this.dataSource = this.historyService.getHistoryData(this.entityName, this.selectedRowData)
    }


  }

  onFormChange($event: any) {

  }

  setKaydedenKisi($event: any) {
    if($event === null){
      this.historyFormData.kaydedenKod = null
    } else {
      this.historyFormData.kaydedenKod = $event?.Kod
    }
  }

  setSonDegistirenKisi($event: any) {
    if($event === null){
      this.historyFormData.sonDegistirenKod =null
    } else {
      this.historyFormData.sonDegistirenKod = $event?.Kod
    }

  }



  // 12.10.2026 LOG_AUDIT: JSON.parse korumalı tek yardımcıya alındı, taşma işaretçisi ({"_ek":"..."}) ve
  // satır kaynağı (KAYNAK) eklendi. Eski gövde aşağıda yorumda.
  onSelectHistoryRow($event: any) {
    if(!$event?.data?.Kod){
      return;
    }
    const satir = $event.data;
    this.HistoryRowSelected = true;
    this.kaynakMetni = null;
    this.eskiDegerKolonu = this.jsonKolonlari(satir.EskiDegerler);
    this.yeniDegerKolonu = this.jsonKolonlari(satir.YeniDegerler);

    // Taşan JSON (LOG_AUDIT_EK, KOD = LOG_AUDIT.KOD) ve kaynak bilgisi yalnız gerektiğinde istenir; tablo/kolon yoksa servis boş döner.
    const eskiTasti = this.tasmaVarMi(satir.EskiDegerler);
    const yeniTasti = this.tasmaVarMi(satir.YeniDegerler);
    const secilenKod = satir.Kod;
    this.seciliKod = secilenKod;
    // Create satırları hep BS kaynaklı (trigger INSERT loglamıyor); taşma da yoksa istek atılmaz.
    if (satir.Islem === 'Create' && !eskiTasti && !yeniTasti) {
      return;
    }
    this.historyService.getLogAuditDetay({kod: secilenKod})
      .pipe(takeUntil(this.destroy$))
      .subscribe(detay => {
        if (this.seciliKod !== secilenKod) {
          return; // bu arada başka satır seçildi
        }
        if (eskiTasti && detay?.eskiDegerler) {
          this.eskiDegerKolonu = this.jsonKolonlari(detay.eskiDegerler);
        }
        if (yeniTasti && detay?.yeniDegerler) {
          this.yeniDegerKolonu = this.jsonKolonlari(detay.yeniDegerler);
        }
        this.kaynakMetni = this.kaynakAciklamasi(detay?.kaynak);
      });
  }

  kaynakMetni: string | null = null;
  private seciliKod: any = null;

  /** JSON metnini {key, value} listesine çevirir; bozuk JSON ekranı düşürmez, ham metin gösterilir. */
  private jsonKolonlari(metin: string): {key: string, value: any}[] {
    if (!metin) {
      return [];
    }
    let nesne: any;
    try {
      nesne = JSON.parse(metin);
    } catch {
      return [{ key: '(çözülemeyen değer)', value: metin }];
    }
    if (!nesne || typeof nesne !== 'object') {
      return [];
    }
    const liste: {key: string, value: any}[] = [];
    for (const key in nesne) {
      if (Object.prototype.hasOwnProperty.call(nesne, key)) {
        liste.push({ key: key, value: nesne[key] });
      }
    }
    return liste;
  }

  /** {"_ek":true} işaretçisi mi? (tam JSON LOG_AUDIT_EK'te; C# AuditKapsam.TasmaIsaretcisi / PGD_LOG_AUDIT.SP_YAZ) */
  private tasmaVarMi(metin: string): boolean {
    if (!metin || metin.indexOf('"_ek"') < 0) {
      return false;
    }
    try {
      const nesne = JSON.parse(metin);
      return !!nesne && nesne._ek === true && Object.keys(nesne).length === 1;
    } catch {
      return false;
    }
  }

  /** LOG_AUDIT.KAYNAK: boş/BS → gösterilmez; PAKET; DB:kullanici@makine. */
  private kaynakAciklamasi(kaynak: string): string | null {
    if (!kaynak || kaynak === 'BS') {
      return null;
    }
    if (kaynak === 'PAKET') {
      return 'Paket (veritabanı prosedürü)';
    }
    if (kaynak === 'GEN_LOG') {
      return 'Eski sistem (Forms dönemi GEN_LOG kaydı, taşındı)';
    }
    if (kaynak.startsWith('DB:')) {
      return `Veritabanı (${kaynak.substring(3)})`;
    }
    return kaynak;
  }

  // onSelectHistoryRow($event: any) {
  //   if($event?.data.Kod){
  //   this.eskiDegerKolonu=[]
  //   this.yeniDegerKolonu=[]
  //   this.HistoryRowSelected= true
  //   if(!!$event.data.YeniDegerler && !$event.data.EskiDegerler){
  //     const yeniDegerlerJson = JSON.parse($event.data.YeniDegerler)
  //     for (let key in yeniDegerlerJson) {
  //       if (yeniDegerlerJson.hasOwnProperty(key)) {
  //         this.yeniDegerKolonu.push({ key: key, value: yeniDegerlerJson[key] });
  //       }
  //     }
  //   }else if(!$event.data.YeniDegerler && !!$event.data.EskiDegerler){
  //     const eskiDegerlerJson = JSON.parse($event.data.EskiDegerler)
  //     for (let key in eskiDegerlerJson) {
  //       if (eskiDegerlerJson.hasOwnProperty(key)) {
  //         this.eskiDegerKolonu.push({ key: key, value: eskiDegerlerJson[key] });
  //       }
  //     }
  //   }else{
  //     const yeniDegerlerJson = JSON.parse($event.data.YeniDegerler)
  //     for (let key in yeniDegerlerJson) {
  //       if (yeniDegerlerJson.hasOwnProperty(key)) {
  //         this.yeniDegerKolonu.push({ key: key, value: yeniDegerlerJson[key] });
  //       }
  //     }
  //     const eskiDegerlerJson = JSON.parse($event.data.EskiDegerler)
  //     for (let key in eskiDegerlerJson) {
  //       if (eskiDegerlerJson.hasOwnProperty(key)) {
  //         this.eskiDegerKolonu.push({ key: key, value: eskiDegerlerJson[key] });
  //       }
  //     }
  //   }
  //   }
  // }



}
